/** Mateix criteri que revisiones/asistente (format nou i antic amb o sense separadors). */
export const MATRICULA_COCHE_REGEX =
  /^([0-9]{4}[-\s.]*[A-Za-z]{3}|[A-Za-z]{1,2}?[-\s.]*[0-9]{4}[-\s.]*[a-zA-Z]{1,2}?)$/

export const MATRICULA_RODIMOTOR_REGEX =
  /^(([A-Za-z]{2}[-\s.]*\d{2}[-\s.]*(\d{2}|[A-Za-z]{2}))|(\d{2}[-\s.]*(\d{2}[-\s.]*[A-Za-z]{2}|[A-Za-z]{2}[-\s.]*\d{2})))$/

export function isMatriculaCocheValid(matricula: string): boolean {
  return MATRICULA_COCHE_REGEX.test(matricula.trim())
}

export function normalizeMatricula(matricula: string) {
  return matricula.toUpperCase().replace(/[^0-9A-Z]+/g, '')
}
